var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostpaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5813 0.106689H0V29.2693H14.5813C22.6342 29.2693 29.1626 22.7408 29.1626 14.688C29.1626 6.63512 22.6342 0.106689 14.5813 0.106689ZM6.62413 12.6235C4.93563 12.6235 3.56842 11.2563 3.56842 9.56778C3.56842 7.87927 4.93563 6.51206 6.62413 6.51206C8.31263 6.51206 9.67984 7.87927 9.67984 9.56778C9.67984 11.2563 8.31263 12.6235 6.62413 12.6235Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62413 35.8933C10.2825 35.8933 13.2483 32.9276 13.2483 29.2692C13.2483 25.6107 10.2825 22.645 6.62413 22.645C2.96572 22.645 0 25.6107 0 29.2692C0 32.9276 2.96572 35.8933 6.62413 35.8933Z",
    fill: "#183887"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostpaid);
export default __webpack_public_path__ + "static/media/Postpaid.33fee1a806bcae40c04e67cdfd116622.svg";
export { ForwardRef as ReactComponent };